import { render, staticRenderFns } from "./NewMultiPropService.vue?vue&type=template&id=7353c593"
import script from "./NewMultiPropService.vue?vue&type=script&lang=js"
export * from "./NewMultiPropService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports